import { useCallback, useState } from "react";
import { supabase } from "@/lib/supabase";

export interface RedeemedLicense {
  id: number;
  license_key: string;
  product_name: string;
  edition: string;
  seat_count: number;
  max_activations: number;
  status: string;
  issued_at: string | null;
  expires_at: string | null;
}

interface UseRedeemCodeResult {
  submitting: boolean;
  redeem: (code: string) => Promise<RedeemedLicense>;
}

// 客户自助核销原始激活码：调用后端公开核销接口，成功后返回新签发的许可证。
export function useRedeemCode(): UseRedeemCodeResult {
  const [submitting, setSubmitting] = useState(false);

  const redeem = useCallback(async (code: string) => {
    setSubmitting(true);
    try {
      const { data, error } = await supabase.functions.invoke("license-redeem", { body: { code } });
      if (error) {
        let message = error.message || "核销失败，请稍后重试";
        try {
          const context = (error as { context?: Response }).context;
          if (context) {
            const parsed = await context.json();
            if (parsed?.error) message = parsed.error;
          }
        } catch {
          // keep original message
        }
        throw new Error(message);
      }
      const result = data as { error?: string; license?: RedeemedLicense } | null;
      if (result?.error) throw new Error(result.error);
      if (!result?.license) throw new Error("核销失败，请稍后重试");
      return result.license;
    } finally {
      setSubmitting(false);
    }
  }, []);

  return { submitting, redeem };
}